/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsAdvertisementOptions } from './FxIdDomainSettingsAdvertisementOptions';
import {
    instanceOfFxIdDomainSettingsAdvertisementOptions,
    FxIdDomainSettingsAdvertisementOptionsFromJSON,
    FxIdDomainSettingsAdvertisementOptionsFromJSONTyped,
    FxIdDomainSettingsAdvertisementOptionsToJSON,
} from './FxIdDomainSettingsAdvertisementOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisement
 * Настройки для рекламы
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisement = FxIdDomainSettingsAdvertisementOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisement {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisement {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementOptions(json)) {
        return FxIdDomainSettingsAdvertisementOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisementToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsAdvertisement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsAdvertisementOptions(value)) {
        return FxIdDomainSettingsAdvertisementOptionsToJSON(value as FxIdDomainSettingsAdvertisementOptions);
    }

    return {};
}

